export default {
    setTwoFactorAuth(state, payload) {
        state.user.otpToken = payload.code;
        state.user.canProceedWithOtp = true;
        state.user.ntUsername = payload.username;
    },
    clearTwoFactorAuth(state) {
        state.user.otpToken = null;
        state.user.ntUsername = null;
        state.user.canProceedWithOtp = false;
    },
    setUser(state, payload) {
        state.user.token = payload.token;
        state.user.autoLoggedOut = false;
        state.user.tokenExpiration = payload.expiresIn;
        state.user.refreshToken = payload.refreshToken;
        state.user.refreshTokenExpiration = payload.refreshExpiresIn;
    },
    clearUser(state) {
        state.user.token = null;
        state.user.tokenExpiration = null;
        state.user.refreshToken = null;
        state.user.refreshTokenExpiration = null;
    },
    setUserClientContext(state, payload) {
        state.user.email = payload.email;
        state.user.userId = payload.userId;
        state.user.isSuper = payload.isSuper;
        state.user.fullName = payload.fullName;
        state.user.isDomain = payload.isDomain;
        state.user.phone = payload.phone || null;
        state.user.ntUsername = payload.ntUsername;
        state.user.languageId = payload.languageId;
        state.user.uiPermissions = payload.uiPermissions;
        state.user.verificationSelectId = payload.verificationSelectId;
        state.user.registeredWorkspaces = payload.registeredWorkspaces;
        state.user.activeWorkspaceSources = payload.activeWorkspaceSources;
        state.user.isScheduledReplyEnabled = payload.isScheduledReplyEnabled ?? false;
    },
    clearUserClientContext(state) {
        state.user.email = null;
        state.user.phone = null;
        state.user.userId = null;
        state.user.fullName = null;
        state.user.isSuper = false;
        state.user.isDomain = false;
        state.user.ntUsername = null;
        state.user.languageId = null;
        state.user.uiPermissions = [];
        state.user.verificationSelectId = 0;
        state.user.canProceedWithOtp = false;
        state.user.registeredWorkspaces = [];
        state.user.activeWorkspaceSources = [];
        state.user.isScheduledReplyEnabled = false;
    },
    clearPasswordPermission(state) {
        state.user.passwordResetUser = null;
        state.user.canChangePassword = false;
    },
    setAutoLogout(state) {
        state.user.autoLoggedOut = true;
    },
    putLangugage(state, payload) {
        state.user.languageId = payload.langId;
    },
    checkExpiredAccounts(state, payload) {
        if (payload) {
            state.user.expiredAccountsCount = payload.data;
            state.user.hasExpiredAccounts = payload.data > 0;
        }
    },
    putOperationStatus(state, payload) {
        state.user.operationStatusActive = payload == "active" ? true : false;
    },
    checkLastestOperationTime(state, payload) {
        if (payload.data) {
            const isUserPassive = payload.data.isUserLogOff;

            if (isUserPassive) {
                state.user.operationStatusActive = false;
            } else {
                state.user.operationStatusActive = true;
            }

            const isUserIdle = payload.data.isUserIdle;

            if (isUserIdle) {
                state.user.operationStatusIdle = true;
            } else {
                state.user.operationStatusIdle = false;
            }
        }
    },
    setExpiredAccounts(state, payload) {
        state.user.expiredAccounts = payload.data;
    },
    updateUserProfile(state, payload) {
        if (payload.email) state.user.email = payload.email;
        if (payload.phone) state.user.phone = payload.phone;
        if (payload.fullName) state.user.fullName = payload.fullName;
    },
    setPasswordResetPermission(state, payload) {
        state.user.canChangePassword = payload.canUpdatePassword;
    },
    setPasswordResetUser(state, payload) {
        state.user.passwordResetUser = payload;
    },
    setPasswordChangeStatus(state, payload) {
        state.user.isPasswordChanged = payload;
    },
    forceResetPassword(state, payload) {
        state.user.canChangePassword = true;
        state.user.passwordResetUser = payload.username;
    },
    setSessionEnd(state, payload) {
        state.user.isSessionEnding = payload.sessionEnding;
    },
    fireSessionTimeoutNotification(state, payload) {
        state.user.fireSessionNotification = payload.showNotification;
        state.user.remainingSessionTime = payload.remainingSeconds;
    },
    setUserIdleStatus(state, payload) {
        state.user.operationStatusIdle = payload;
    },
    setOperationQueue(state, payload) {
        state.user.operationQueueId = payload;
    }
};